import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const FoodMenuService = {
  getFoodMenu: async (orgCode) => {
    const response = await apiService.get(`/api/menuitem/org/${orgCode}`);
    return response.data;
  },

  getSpecialItems: async ({pageNumber=1, pageSize=10})=>{
    try{
      const res = await apiService.get(`api/menuitem/specialitems?pageNumber=${pageNumber}&pageSize=${pageSize}`);
      // console.log(res)
      return res.data.data
    }catch(err){
      console.log("error while fetching special items. ERR: ", err)
    }
   
  }


};

export default FoodMenuService;
